'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _Spinner = _interopRequireDefault(require('./lib/icons/Spinner'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _Spinner;
  exports.default = _default;
  module.exports = _default;